import ValidationRule from './ValidationRule';

class RegExPatternValidationRule extends ValidationRule {
  validate(val) {
    return this.pattern.test(val);
  }
}

export default RegExPatternValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/RegExPatternValidationRule.js